module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/favicon_ohiolink_2_c35f921.ico";